export default {
  noAuthLookPage: '抱歉，你无权访问该页面',

}